import { useQuery } from '@tanstack/react-query';
import { PsychosocialReportService } from '@/infra/services/psychosocial-report';

export interface GetValidateSurveyTokenParams {
	token_survey: string;
}

const Service = PsychosocialReportService.getInstance();

export const useGetValidateSurveyToken = (params: GetValidateSurveyTokenParams) => {
	return useQuery({
		queryFn: async () => Service.getValidateSurveyToken(params),
		enabled: !!params.token_survey,
		retry: false
	});
};
